import { publicClient, privateClient } from './client';
import { RequisitionList } from './RequisitionList';

const transactionsRequisitionList = (pub: boolean) => new RequisitionList(pub ? publicClient : privateClient);
export default transactionsRequisitionList;
